import React, {StrictMode} from 'react';
import ReactDOM from 'react-dom';
import Form from './Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fontsource/roboto";

const main = document.getElementsByTagName('main')[0];
// console.log(main);

ReactDOM.render(
  <StrictMode>
    <Form />
  </StrictMode>,
  main
);